export const FETCH_GUIDELINES = 'GUIDELINES/FETCH/REQUEST';
export const FETCH_GUIDELINES_SUCCESS = 'GUIDELINES/FETCH/SUCCESS';
export const FETCH_GUIDELINES_FAILURE = 'GUIDELINES/FETCH/FAILURE';

export const FIND_GUIDELINES_DEALER_OR_GROUP = 'GUIDELINES/FIND_BY_DEALER_OR_GROUP/REQUEST';
export const FIND_GUIDELINES_DEALER_OR_GROUP_SUCCESS = 'GUIDELINES/FIND_BY_DEALER_OR_GROUP/SUCCESS';

export const FETCH_GUIDELINE = 'GUIDELINE/FETCH/REQUEST';
export const FETCH_GUIDELINE_SUCCESS = 'GUIDELINE/FETCH/SUCCESS';
export const FETCH_GUIDELINE_FAILURE = 'GUIDELINE/FETCH/FAILURE';

export const POST_GUIDELINE = 'GUIDELINE/POST/REQUEST';
export const POST_GUIDELINE_SUCCESS = 'GUIDELINE/POST/SUCCESS';
export const POST_GUIDELINE_FAILURE = 'GUIDELINE/POST/FAILURE';

export const PUT_GUIDELINE = 'GUIDELINE/PUT/REQUEST';
export const PUT_GUIDELINE_SUCCESS = 'GUIDELINE/PUT/SUCCESS';
export const PUT_GUIDELINE_FAILURE = 'GUIDELINE/PUT/FAILURE';

export const DELETE_GUIDELINE = 'GUIDELINE/DELETE/REQUEST';
export const DELETE_GUIDELINE_SUCCESS = 'GUIDELINE/DELETE/SUCCESS';
export const DELETE_GUIDELINE_FAILURE = 'GUIDELINE/DELETE/FAILURE';

export const SELECT_GUIDELINE = 'GUIDELINE/SELECT';
export const SET_DASHBOARD_FILTER = 'GUIDELINES/DASHBOARD/SET/FILTER';
export const SET_DASHBOARD_FILTERS = 'GUIDELINES/DASHBOARD/SET/FILTERS';
export const REMOVE_DASHBOARD_FILTER = 'GUIDELINES/DASHBOARD/REMOVE/FILTER';

export const ASSIGN_BRANDS_TO_GUIDELINE = 'GUIDELINE/ASSIGN/BRANDS/REQUEST';
export const ASSIGN_BRANDS_TO_GUIDELINE_SUCCESS = 'GUIDELINE/ASSIGN/BRANDS/SUCCESS';
export const ASSIGN_BRANDS_TO_GUIDELINE_FAILURE = 'GUIDELINE/ASSIGN/BRANDS/FAILURE';

export const POST_CLONE_GUIDELINE = 'GUIDELINE/CLONE/POST/REQUEST';
export const POST_CLONE_GUIDELINE_SUCCESS = 'GUIDELINE/CLONE/POST/SUCCESS';
export const POST_CLONE_GUIDELINE_FAILURE = 'GUIDELINE/CLONE/POST/FAILURE';

export const OPEN_ASSIGN_MODAL = 'GUIDELINE/ASSIGN/MODAL/OPEN';
export const CLOSE_ASSIGN_MODAL = 'GUIDELINE/ASSIGN/MODAL/CLOSE';
export const ASSIGN_MODAL_READY = 'GUIDELINE/ASSIGN/MODAL/SUCCESS';
export const ASSIGN_MODAL_FAILURE = 'GUIDELINE/ASSIGN/MODAL/FAILURE';

export const OPEN_DUPLICATE_MODAL = 'GUIDELINE/DUPLICATE/MODAL/OPEN';
export const CLOSE_DUPLICATE_MODAL = 'GUIDELINE/DUPLICATE/MODAL/CLOSE';

export const PREVIEW_GUIDELINE = 'GUIDELINE/PREVIEW/REQUEST';
export const PREVIEW_GUIDELINE_SUCCESS = 'GUIDELINE/PREVIEW/SUCCESS';
export const PREVIEW_GUIDELINE_FAILURE = 'GUIDELINE/PREVIEW/FAILURE';

export const PREVIEW_GUIDELINE_UPDATED = '@@SOCKET/TOPIC:DETAILS/GUIDELINE/CLIPPED';
